import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core'

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss']
})
export class SwitchComponent implements OnInit {
  @Input() btnTextOn: string = 'Yes'
  @Input() btnTextOff: string = 'No'
  @Input() value: boolean = false
  @Input() isDisabled: boolean = false

  @Output() valueChange = new EventEmitter<boolean>()

  uniqueId: string

  ngOnInit() {
    this.uniqueId = this.generateUniqueId()
  }

  toggleValue(event: Event): void {
    this.value = (event.target as HTMLInputElement).checked
    this.valueChange.emit(this.value)
  }

  private generateUniqueId(): string {
    const randomPart = Math.random().toString(36).substring(2, 11)
    const timestampPart = Date.now().toString(36)
    return `switch-${randomPart}-${timestampPart}`
  }
}
